import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

const wrapperStyle = {
  // Cap the wrapper at its parent's width so a wide table scrolls inside this
  // container instead of stretching the page past the viewport.
  width: '100%',
  maxWidth: '100%',
  overflowX: 'auto', // change to scroll if needed
  overflowY: 'auto',
  // paddingBottom: '16px', // space for scrollbar
  // paddingRight: '16px', // space for scrollbar
  // scrollbarGutter: 'stable both-edges',
  scrollbarGutter: 'stable right',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': { height: '10px', width: '10px' }, // thicker scrollbar
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(100,100,100,0.5)',
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-track': { backgroundColor: 'rgba(0,0,0,0.05)' },
};

export type ScrollableContainerProps = {
  isContainedWithScroll?: boolean;
  containerSx?: BoxProps['sx'];
};

/**
 * Higher-Order Component that wraps a component with a scrollable container
 * when the `isContainedWithScroll` prop is true.
 */
function withScrollableContainer<P extends object>(
  WrappedComponent: React.ComponentType<P>,
) {
  // Define the prop for controlling scroll behavior
  type EnhancedProps = P & ScrollableContainerProps;

  const WithScrollableContainer: React.FC<EnhancedProps> = ({
    isContainedWithScroll = true,
    containerSx = {},
    ...rest
  }) => {
    if (isContainedWithScroll) {
      return (
        <Box sx={{ ...wrapperStyle, ...containerSx }}>
          <WrappedComponent {...(rest as P)} />
        </Box>
      );
    }

    return <WrappedComponent {...(rest as P)} />;
  };

  WithScrollableContainer.displayName = `WithScrollableContainer(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithScrollableContainer;
}

export default withScrollableContainer;
